var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"vl"}),_vm._v(" "),_c('div',{staticClass:"condition-connection-line font-16 font-gilroy font-weight-500"},[_vm._v(_vm._s(_vm.connection_text))]),_vm._v(" "),_c('div',{staticClass:"vl"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f6d17fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/automation/automationSharedView/connectionLine.vue
// module id = null
// module chunks = 